import React from 'react';
import AdminHeader from '../../components/adminHeader';
import AdminFooter from '../../components/adminFooter';

const PartnerDash = () => {
  return (
    <div className="w-full h-full flex flex-col bg-[#00000071]">
      <AdminHeader />
      <div
        style={{
          backgroundImage: "url(/assets/img/landing/landing-bg.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="flex-grow flex flex-col items-center justify-center w-full relative pt-6 px-4"
      >
        <div className="gothic-panel w-full max-w-4xl p-8">
          <h1 className="gothic-heading text-center mb-6">Partner Dashboard</h1>
          <div className="space-y-4">
            <p className="gothic-text-silver">Welcome to your partner dashboard! Here you can manage your rewards, track your earnings, and handle your payments.</p>
            {/* Add sections for rewards management, earnings tracking, payment management */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
              <div className="gothic-panel p-6">
                <h2 className="gothic-heading mb-4">Manage Rewards</h2>
                <p className="gothic-text-silver">View and manage the rewards you offer to your audience.</p>
                <button className="gothic-button gothic-button-primary mt-4">Go to Rewards</button>
              </div>
              <div className="gothic-panel p-6">
                <h2 className="gothic-heading mb-4">Earnings & Payments</h2>
                <p className="gothic-text-silver">Track your earnings and manage your payment methods.</p>
                <button className="gothic-button gothic-button-primary mt-4">View Earnings</button>
              </div>
              <div className="gothic-panel p-6">
                <h2 className="gothic-heading mb-4">Profile Settings</h2>
                <p className="gothic-text-silver">Update your personal and account information.</p>
                <button className="gothic-button gothic-button-primary mt-4">Edit Profile</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminFooter />
    </div>
  );
};

export default PartnerDash;
